import { render } from "./editOrder.vue?vue&type=template&id=84e1611c&scoped=true"
import script from "./editOrder.vue?vue&type=script&lang=js"
export * from "./editOrder.vue?vue&type=script&lang=js"

import "./editOrder.vue?vue&type=style&index=0&id=84e1611c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-84e1611c"

export default script